<template>
  <div></div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'LocationAutocompletRequester',
  components: {},
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      latestSearchDate: 0,
    }
  },
  beforeUnmount() {},
  mounted() {},
  methods: {
    async search(text = this.text) {
      this.$emit('searching')
      const latestSearchDate = Date.now()
      this.latestSearchDate = latestSearchDate
      let res
      if (!text) res = []
      else {
        res = await this.$Events.sendDataRequestResolve(
          'geolocationAutocomplet',
          { text },
          9999999999,
        )
      }
      console.log(res, text)
      if (this.latestSearchDate !== latestSearchDate) return
      this.$emit('result', res || [])
    },
    debunceSearch: debounce(function (text, filters) {
      this.search(text, filters)
    }, 1000),
  },
  watch: {
    text(newText) {
      this.$emit('searching')
      this.debunceSearch(newText)
    },
  },
}
</script>
